import React, {
    IframeHTMLAttributes,
    memo,
    ReactElement,
    useMemo,
} from 'react';
import './NewVideo.css';
import { LinkWrapper } from '../../LinkWrapper/LinkWrapper';

export interface IVideoProps extends IframeHTMLAttributes<any> {
    youtubeEmbedURL: string;
    title: string;
    metaThumbnailURL?: string | undefined;
    metaDescription?: string | undefined;
    metaUploadDate?: string | undefined;
    altText?: string;
    videoHeight?: string;
    videoWidth?: string;
    videoDisclaimer?: ReactElement | ReactElement[] | JSX.Element | null;
    allow?: string;
}

const Video = memo(
    ({
        className = '',
        youtubeEmbedURL,
        title,
        metaThumbnailURL,
        metaDescription,
        metaUploadDate,
        altText,
        videoDisclaimer,
        videoHeight,
        videoWidth,
        allow = '',
    }: IVideoProps) => {

        const id = useMemo(() => {
            if (!title) {
                return '';
            };
            let idTitle = title;
            if (idTitle.indexOf('|') !== -1) {
                idTitle = idTitle.substring(0, title.indexOf('|') - 1);
            }
            return idTitle
                .replace(/[^a-zA-Z0-9 ]/g, '')
                .replace(/\s+/g, '-')
                .toLowerCase();
        }, [title]);

        // Guarantees Rel=0 and EnableJSapi params. Is done repeatedly when handling the youtube urls
        const fullVideoUrl = useMemo(() => {
            let videoUrl = youtubeEmbedURL;
            let paramsOut = new URLSearchParams('?rel=0&enablejsapi=1')

            if(videoUrl.includes('?')){
                let paramsIn = new URLSearchParams(videoUrl.substring(videoUrl.indexOf('?')));
                videoUrl = videoUrl.substring(0, videoUrl.indexOf('?'));

                for (const [key, value] of paramsIn.entries()) {
                    paramsOut.set(key, value);
                }
            }

            return videoUrl + '?' + paramsOut.toString();
        }, [ youtubeEmbedURL ]);

        if (
            !youtubeEmbedURL ||
            !fullVideoUrl ||
            !id
        ) {
            return null;
        }

        return (
            <>
                <div
                    className={`NewVideo ${className}`}
                    tabIndex={0}
                    itemScope
                    itemType='http://schema.org/VideoObject'
                    style={{
                        height: videoHeight ? videoHeight : undefined,
                        width: videoWidth ? videoWidth : undefined,
                    }}
                    aria-details={altText ? altText : undefined}
                >
                    <meta itemProp='name' content={title} />
                    {metaThumbnailURL &&
                        <meta itemProp='thumbnailURL' content={metaThumbnailURL} />
                    }
                    <meta
                        itemProp='embedURL'
                        content={fullVideoUrl}
                    />
                    {metaDescription &&
                        <meta itemProp='description' content={metaDescription} />
                    }
                    {metaUploadDate &&
                        <meta itemProp='uploadDate' content={metaUploadDate} />
                    }
                    <iframe
                        title={'Video titled ' + title}
                        width='100%'
                        height='100%'
                        src={fullVideoUrl}
                        id={'c1b-video-' + id}
                        allow={allow}
                    />
                </div>
                {videoDisclaimer || videoDisclaimer === null ? (
                    videoDisclaimer
                ) : (
                    <p className='ytdisclaimer'>
                        Credit One Bank uses YouTube API services and by watching the video, 
                        you are agreeing to the YouTube Terms of Service (
                        <LinkWrapper target={'_self'} href={'https://youtube.com/terms'}>https://youtube.com/terms</LinkWrapper>)
                        and Google Privacy Policy (
                        <LinkWrapper target={'_self'} href='https://www.google.com/policies/privacy'>
                        https://www.google.com/policies/privacy
                        </LinkWrapper>
                        ).
                    </p>
                )}
            </>
        );
    },
);
export default Video;
